// Utilities extracted from PlatformModule.js

import _ from "lodash";
import React from "react";
import { getOrganizationFreeStatus } from "../PlatformUtils";

//Context to store User curriculum programs
export const UserCurriculumProgramsContext = React.createContext();

export const getCurriculumProgramFreeStatus = ({
  state,
  tabConfigurations,
}) => {
  const activeTab = _.get(state, "login.activeTab", "");

  const organizationCurriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  switch (activeTab) {
    case "teacher": {
      const { curriculumProgramId } = _.get(tabConfigurations, "teacher", {});

      const currentCurriculumProgramId =
        curriculumProgramId ||
        _.get(state, "platform.currentCurriculumProgram.id", {});

      const currentCurriculumProgram = _.find(
        organizationCurriculumPrograms,
        ({ id }) => id == currentCurriculumProgramId
      );

      /**
       * For cases when this util is called before active curriculum program is set, organization will be treated as paid.
       * Some components in ChildrenPage are shown for free curriculums. To avoid rendering them before state is set, return value is set false.
       **/
      if (_.isEmpty(currentCurriculumProgram)) {
        return false;
      }
      return _.get(currentCurriculumProgram, "subscriptionPlan.isFree", false);
    }
    case "admin": {
      const { curriculumProgramId } = _.get(tabConfigurations, "admin", {});
      const activeCurriculumProgram = _.find(
        organizationCurriculumPrograms,
        ({ id }) => id == curriculumProgramId
      );

      if (_.isEmpty(activeCurriculumProgram)) {
        return getOrganizationFreeStatus({
          curriculumPrograms: organizationCurriculumPrograms,
        });
      }

      return _.get(activeCurriculumProgram, "subscriptionPlan.isFree", false);
    }

    default: {
      /**
       *This is used for visitor and onboarding active tab
       */
      return getOrganizationFreeStatus({
        curriculumPrograms: organizationCurriculumPrograms,
      });
    }
  }
};

//TODO: move it to PlatformUtils
export const getPlannerElementSetsGroupedByType = ({
  organizationCurriculumPrograms,
  curriculumProgramId,
}) => {
  const { plannerElementSets } =
    _.find(organizationCurriculumPrograms, {
      id: curriculumProgramId,
    }) || {};

  return _.reduce(
    plannerElementSets,
    (result, plannerElementSet) => {
      result[plannerElementSet.type] = plannerElementSet;
      return result;
    },
    {}
  );
};

export const selectedAcademicYearSelector = state =>
  _.get(state, "platform.academicYearSelected", {});

export const getProcessedCustomIconsFromStore = state =>
  _.get(state, "platform.customIcons", []);
